module.exports = __webpack_public_path__ + "static/image1-fb139b6e68741425c9e3c130f84eb1af.jpg";